import AutoNumeric from 'autonumeric';

const instances = new WeakMap();

// Compare model echoes without converting money through Number. AutoNumeric
// drops padded zeros from rawValue, while a component may keep e.g. "12.50".
// Empty/null model values have historically meant zero in these amount forms.
function comparableAmount(value) {
  const text = value == null || value === '' ? '0' : String(value);
  const match = /^(-?)(\d*)(?:\.(\d*))?$/.exec(text);
  if (!match || (!match[2] && !match[3])) return text;
  const whole = match[2].replace(/^0+(?=\d)/, '') || '0';
  const fraction = (match[3] || '').replace(/0+$/, '');
  const sign = match[1] && (whole !== '0' || fraction) ? '-' : '';
  return sign + whole + (fraction ? `.${fraction}` : '');
}

function modelAmount(element) {
  return element.getAttribute('rawvalue') || '0';
}

function sameOptions(previous, next) {
  const keys = Object.keys(previous);
  return keys.length === Object.keys(next).length &&
    keys.every(key => Object.prototype.hasOwnProperty.call(next, key) && Object.is(previous[key], next[key]));
}

function mount(element, binding) {
  if (instances.has(element)) return;
  const options = { ...(binding.value || {}) };
  const numeric = new AutoNumeric(element, modelAmount(element), options);
  element.autonumeric = numeric;
  instances.set(element, { numeric, options });
}

export default {
  mounted: mount,
  updated(element, binding) {
    const state = instances.get(element);
    if (!state) return;
    const options = binding.value || {};
    if (!sameOptions(state.options, options)) {
      // Update only an actual mask change (currency, locale, precision...).
      // A newly allocated equivalent options object must not disturb editing.
      const changes = { ...options };
      Object.keys(state.options).forEach(key => {
        if (!Object.prototype.hasOwnProperty.call(options, key)) changes[key] = AutoNumeric.defaultSettings[key];
      });
      state.numeric.update(changes);
      state.options = { ...options };
    }
    const value = modelAmount(element);
    if (comparableAmount(value) !== comparableAmount(state.numeric.getNumericString())) {
      // Programmatic changes such as Usar todo or a source reset still apply.
      // For an input echo, let AutoNumeric keep its decimal text and caret.
      state.numeric.set(value);
    }
  },
  beforeUnmount(element) {
    const state = instances.get(element);
    if (!state) return;
    state.numeric.remove();
    if (element.autonumeric === state.numeric) delete element.autonumeric;
    instances.delete(element);
  },
};
